export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/runWorker.441ecfe3.worker.js");
}
